import { injectable } from 'inversify';

import { OperationResult, Success } from '@vp/common/core/OperationResult';
import { ProfileAccessStorage } from '@vp/profile/core/interface/ProfileAccessStorage';
import { ProfileRepository } from '@vp/profile/core/interface/ProfileRepository';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

@injectable()
export class UnlockProfileUsecase {
  constructor(
    private readonly profileRepository: ProfileRepository,
    private readonly profileAccessStorage: ProfileAccessStorage,
  ) {}

  async execute(id: string, code: string, constroller?: AbortController): Promise<OperationResult<ProfileModel>> {
    const result = await this.profileRepository.unlockProfile(id, code, constroller);

    if (result instanceof Success) {
      await this.profileAccessStorage.saveAccess(id, code);
    }

    return result;
  }
}
